// extracted by mini-css-extract-plugin
export default {"root":"FooterWrapper_root__27uxv"};